"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        overflow: 'hidden',
        transform: 'translateZ(0)',
        borderRadius: 2,
        maxHeight: 'inherit',
        boxShadow: `2px 3px 10px 0 rgba(0,0,0,0.1)`,
        '&[data-is-open="true"]': {
            border: `1px solid ${theme.indigo3}`
        },
        '&[data-is-invalid="true"]': {
            borderColor: theme.warningRed
        }
    },
    options: {
        overflow: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        backgroundColor: 'inherit',
        maxHeight: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        position: 'relative',
        zIndex: 0,
        paddingTop: 35,
        '&::-webkit-scrollbar': {
            width: 6
        },
        '&::-webkit-scrollbar-track': {
            background: theme.grey5,
            borderRadius: 10
        },
        '&::-webkit-scrollbar-thumb': {
            background: theme.grey3,
            borderRadius: 10,
            '&:hover': {
                background: theme.grey2
            }
        }
    }
});
//# sourceMappingURL=select.menu.style.js.map